<template>
  <div class="empty-dialog">
    <md-popup
      ref="empty-dialog"
      v-model="dialogVisible"
      @hide="hideDialog"
      :mask-closable="maskClosable"
      :position="position"
    >
      <slot></slot>
    </md-popup>
  </div>
</template>

<script>
import { Popup } from 'mand-mobile'

import dialogMixins from '@/mixins/dialog'

export default {
  name: 'DialogEmpty',
  components: {
    [Popup.name]: Popup,
  },
  props: {
    maskClosable: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: 'center',
    },
    boxWidth: {
      type: String,
      default: '90%',
    },
    maxHeight: {
      type: String,
      default: '70vh',
    },
  },
  mixins: [dialogMixins],
  mounted() {
    const ele = document.querySelector('.empty-dialog .md-popup .md-popup-box')
    ele.style.width = this.boxWidth
    ele.style.height = this.maxHeight
    switch (this.position) {
      case 'bottom': {
        ele.style.borderBottomRightRadius = '0'
        ele.style.borderBottomLeftRadius = '0'
        break
      }
      case 'top': {
        ele.style.borderTopRightRadius = '0'
        ele.style.borderTopLeftRadius = '0'
        break
      }
      case 'left': {
        ele.style.borderTopLeftRadius = '0'
        ele.style.borderBottomLeftRadius = '0'
        break
      }
      case 'right': {
        ele.style.borderTopRightRadius = '0'
        ele.style.borderBottomRightRadius = '0'
        break
      }
    }
  },
}
</script>

<style scoped lang="stylus">
.empty-dialog /deep/ {
  .md-popup-box {
    width: 90%;
    background-color: #fff;
    border-radius: 6px;
  }
}
</style>
